import { Box, Paper, AppBar, Stack, Toolbar, Typography } from "@mui/material";
// Images
import cimicardImage from "../../../Images/cimicard-image.jpg";
import Image from "next/image";

const HeaderInfo = () => {
    return (
        <div>
            <Box sx={{ flexGrow: 1 }}>
                <Paper square variant="outlined" elevation={1}>
                <AppBar position="fixed" sx={{ bgcolor: 'white' }}>
                    <Toolbar>
                        <Image src={cimicardImage} alt="CimiCard Logo" width="197" height="52" />
                        <Typography sx={{ flexGrow: 1 }} />
                            <Stack>
                            <Typography align="right" variant="h4" color="primary">VCO Cash-Out Request*</Typography>
                            <Typography align="right" sx={{ color: 'grey', fontSize: 12 }}>
                                *The VCO Cash-Out Platform is a patent pending product of Card Compliant, LLC.
                            </Typography>
                        </Stack>
                    </Toolbar>
                </AppBar>
                </Paper>
            </Box>
        </div>
    )
}

export default HeaderInfo;